import { render, staticRenderFns } from "./CashBook.vue?vue&type=template&id=4ed7a85d&"
import script from "./CashBook.vue?vue&type=script&lang=js&"
export * from "./CashBook.vue?vue&type=script&lang=js&"
import style0 from "./CashBook.vue?vue&type=style&index=0&id=4ed7a85d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports